import React from 'react'
import { Button, Result } from 'antd'

const ErrorPage:React.FC = () => {
  return (
    <div>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, page does not exist"
          extra={<Button type="primary" onClick={() => {window.location.href = "/"}} style={{backgroundColor: "green", border: "none"}}>Back Home</Button>}
          style={{
            paddingTop: "100px"
          }}
  />
    </div>
  )
}

export default ErrorPage